module.exports = __webpack_public_path__ + "img/twp-logo.a060704b.png";